import React from 'react';

import { PaletteColor } from '@utils/types';

import { Label } from './BorderedLabelStyle';

interface BorderedLabelProps {
  text: string;
  backgroundColor?: PaletteColor;
  color?: PaletteColor;
  borderColor?: PaletteColor;
  entryDateMissing?: boolean;
}

const BorderedLabel = ({
  text,
  backgroundColor,
  color,
  borderColor,
  entryDateMissing,
}: BorderedLabelProps) => {
  const style = entryDateMissing
    ? { position: 'relative' as const, bottom: -205 }
    : {};
  return (
    <Label
      backgroundColor={backgroundColor}
      color={color}
      borderColor={borderColor}
      style={style}
    >
      {text}
    </Label>
  );
};

export default BorderedLabel;
